export const employeeMenuId = "employee-menu";
